// Module
var code = "<!DOCTYPE html> <div class=\"overlay\"> </div>";
// Exports
export default code;